import dayjs from 'dayjs'

export interface Coupon {
  id?: string
  name?: string
  amount_off?: string | number | null
  percent_off?: string | number | null
  currency?: string
  duration?: string
  [key: string]: unknown
}

export type CouponEndDate = string | number | Date | null | undefined

/**
 * Return true iff the coupon's end date lies in the past.
 *
 * A missing / null end means the coupon is forever — treated as active
 * (backwards-compatible with today's behavior where the customer-level
 * coupon is rendered on truthy-coupon alone with no expiry check).
 *
 * Accepts ISO 8601 string (dj-stripe convention), unix epoch seconds
 * (Stripe raw), Date, or null.
 */
export function isCouponExpired(end: CouponEndDate): boolean {
  if (end == null) {
    return false
  }
  const endDate = typeof end === 'number' ? dayjs(end * 1000) : dayjs(end)
  if (!endDate.isValid()) {
    return false
  }
  return endDate.isBefore(dayjs())
}

/**
 * Pick the coupon to display on the Billing page.
 *
 * Precedence mirrors Stripe's invoice behavior: subscription-level wins
 * over customer-level. Expiry is checked BEFORE precedence so an expired
 * subscription coupon does NOT mask an active customer coupon.
 *
 * @returns The active coupon, or null when neither applies.
 */
export function getActiveCoupon(
  subscriptionCoupon: Coupon | null | undefined,
  subscriptionCouponEnd: CouponEndDate,
  customerCoupon: Coupon | null | undefined,
  customerCouponEnd: CouponEndDate
): Coupon | null {
  if (subscriptionCoupon && !isCouponExpired(subscriptionCouponEnd)) {
    return subscriptionCoupon
  }
  if (customerCoupon && !isCouponExpired(customerCouponEnd)) {
    return customerCoupon
  }
  return null
}



// WEBPACK FOOTER //
// ./src/libs/billing/get-active-coupon/index.ts